<div class="search-panel">

  <!-- Bucket selector (linked to Files tab) -->
  <div class="search-field">
    <p-dropdown
      placeholder="Select Bucket"
      [options]="projects"
      optionLabel="name"
      [ngModel]="selectedProject"
      dataKey="name"
      [disabled]="projects.length <= 0"
      (onChange)="onProjectSelect($event)"
      [dropdownIcon]="loadingProjectsIcon()"
      styleClass="w-full"
    ></p-dropdown>
  </div>

  <!-- Sub-path: breadcrumb drill-down -->
  <div class="search-field">
    <p-breadcrumb
      [model]="breadcrumbItems"
      [home]="homeItem"
      styleClass="sub-path-breadcrumb"
      pTooltip="Select to reduce the search to a sub-folder of the project."
      tooltipPosition="right"
    ></p-breadcrumb>
  </div>

  <!-- Overlay panel: folder list for sub-path selection -->
  <p-overlayPanel #subPathOverlay styleClass="sub-path-overlay">
    <div *ngIf="overlayLoading" class="flex align-items-center gap-2 p-2">
      <p-progressSpinner styleClass="overlay-spinner" strokeWidth="4"></p-progressSpinner>
      <span class="text-sm">Loading&hellip;</span>
    </div>
    <div *ngIf="!overlayLoading && overlayFolders.length === 0" class="p-2 text-sm text-color-secondary">
      No sub-folders
    </div>
    <ul *ngIf="!overlayLoading && overlayFolders.length > 0" class="sub-path-folder-list">
      <li
        *ngFor="let folder of overlayFolders"
        class="sub-path-folder-item"
        (click)="onOverlayFolderSelect(folder)"
      >
        <i class="pi pi-folder mr-2"></i>{{ folder.name }}
      </li>
    </ul>
  </p-overlayPanel>

  <!-- Pattern -->
  <div class="search-field">
    <input
      pInputText
      type="text"
      [(ngModel)]="searchPattern"
      placeholder="File name pattern"
      class="w-full"
      pTooltip="Enter search term e.g. *.tif"
      tooltipPosition="right"
      (keyup.enter)="onSearch()"
    />
  </div>

  <!-- Pattern type: radio buttons (one always selected) -->
  <div class="search-field pattern-type-field">
    <div class="pattern-radio">
      <p-radioButton
        name="patternType"
        [value]="PatternType.WILDCARD"
        [(ngModel)]="patternType"
        inputId="ptWildcard"
      ></p-radioButton>
      <label for="ptWildcard" class="ml-1 mr-3">Wildcard</label>
      <p-radioButton
        name="patternType"
        [value]="PatternType.REGEX"
        [(ngModel)]="patternType"
        inputId="ptRegex"
      ></p-radioButton>
      <label for="ptRegex" class="ml-1">Regex</label>
    </div>
  </div>

  <!-- Checkboxes -->
  <div class="search-options">
    <p-checkbox
      [(ngModel)]="caseSensitive"
      [binary]="true"
      inputId="caseSensitive"
      label="Case sensitive"
    ></p-checkbox>
    <p-checkbox
      [(ngModel)]="selectInTree"
      [binary]="true"
      inputId="selectInTree"
      label="Link to 'Files'"
    ></p-checkbox>
  </div>


  <!-- Metadata filters (collapsible) -->
  <p-accordion styleClass="metadata-accordion" [activeIndex]="metadataExpanded ? 0 : null">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <span class="metadata-accordion-header">
          Metadata Filters
          <span *ngIf="metadataFilters.length > 0" class="metadata-filter-count ml-1">
            ({{ metadataFilters.length }})
          </span>
        </span>
      </ng-template>

      <div class="metadata-filter-section">
        <metadata-filter-row
          *ngFor="let draft of metadataFilters; let i = index; trackBy: trackByIndex"
          [draft]="draft"
          (draftChange)="onFilterDraftChange(i, $event)"
          (remove)="removeMetadataFilter(i)"
        ></metadata-filter-row>

        <div *ngIf="metadataFilters.length === 0" class="metadata-empty-hint">
          No metadata filters added yet.
        </div>

        <div class="metadata-filter-add">
          <button
            pButton
            label="Add Filter"
            icon="pi pi-plus"
            class="p-button-text p-button-sm p-button-secondary"
            (click)="addMetadataFilter()"
          ></button>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

  <!-- Search / Cancel buttons -->
  <div class="search-actions">
    <button
      pButton
      label="Search"
      icon="pi pi-search"
      [disabled]="!canSearch()"
      (click)="onSearch()"
      class="p-button-sm"
    ></button>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      [disabled]="!isSearching"
      (click)="onCancel()"
      class="p-button-sm p-button-secondary cancel-btn"
    ></button>
  </div>

  <!-- Status line -->
  <div class="search-status" *ngIf="isSearching">
    <p-progressSpinner styleClass="search-spinner" strokeWidth="4"></p-progressSpinner>
    <span>Searching&hellip; ({{ searchResults.length }} found)</span>
  </div>
  <div class="search-status" *ngIf="!isSearching && searchResults.length > 0">
    Found {{ searchResults.length }} file(s)
  </div>

  <!-- Results list -->
  <div class="search-results">
    <div
      *ngFor="let node of searchResults"
      class="search-result-item"
      [class.selected]="node === selectedResult"
      (click)="onResultSelect(node)"
    >
      <div class="result-main">
        <span [className]="node.icon || 'pi pi-file'"></span>
        <span class="result-label ml-1">{{ node.label }}</span>
        <span
          *ngIf="node.data | instanceof: IFile as file"
          class="result-size text-xs font-italic text-primary ml-1"
        >{{ file.size | filesize }}</span>
      </div>
      <div class="result-path text-xs">{{ node.data?.relPath }}</div>
    </div>
  </div>

</div>
